// Web stub for Sentry – avoids sentry-expo and expo-constants.

export function initSentry() {
  // Optionally, initialise Sentry browser SDK if DSN is present
  const dsn = process.env.EXPO_PUBLIC_SENTRY_DSN;
  if (!dsn) {
    console.warn('[sentry] No DSN provided for web; skipping');
    return;
  }
  import('@sentry/browser')
    .then((Sentry) => {
      Sentry.init({
        dsn,
        // These are expected browser/user behavior, not application bugs, and
        // were the only two issue types this project had accumulated:
        // - AbortError: the user cancelled a native share sheet (navigator.share())
        //   or a fetch was aborted on purpose (e.g. component unmount).
        // - Generic offline/connectivity failures surfaced as a bare "NetworkError".
        // Sentry itself reported 0 users impacted by either before this filter.
        ignoreErrors: [
          'AbortError',
          'Abort due to cancellation of share',
          'NetworkError: A network error occurred.',
        ],
      });
      console.log('[sentry] Browser Sentry initialized');
    })
    .catch(() => {
      console.warn('[sentry] Failed to load @sentry/browser SDK');
    });
}
